<template>
  <div class="app align-items-center">
    <b-container v-if="logout">
      <div class="text-center">
        <h1>{{ $i18n.t('logout.title') }}</h1>
        <h2>
          <span>{{ $i18n.t('logout.close') }}</span>
          <a href="/login">
            <u>{{ $i18n.t('logout.login') }}</u>
          </a>
        </h2>
      </div>
    </b-container>
    <b-container v-else-if="invalid">
      <div class="text-center">
        <h1>{{ $i18n.t('logout.invalidSession') }}</h1>
        <a href="/login">
          <u>{{ $i18n.t('login.retry') }}</u>
        </a>
      </div>
    </b-container>
    <b-container v-else>
      <div v-if="error">
        <h3 class="text-center">{{ $i18n.t('login.sorry') }}</h3>
        <p class="alert alert-danger">"{{ error }}"</p>
        <b-button @click="keycloakAuthentication()">
          {{ $i18n.t('login.retry') }}
        </b-button>
        <p>{{ $i18n.t('login.contact') }}</p>
      </div>
      <div class="text-center" v-else-if="connecting">
        {{ $i18n.t('login.connecting') }}
      </div>
      <p v-else class="m-4 text-secondary text-center">
        {{ $i18n.t('login.redirection') }}
      </p>
    </b-container>
  </div>
</template>

<script>
import { keycloak } from '../config.json';
import { createUserManager } from '../helpers/keycloak';

const TIMEOUT_DURATION = 7000;

export default {
  name: 'loginPage',
  data() {
    return {
      error: null,
      connecting: false,
      logout: this.$route.query.logout,
      invalid: this.$route.query.invalid,
    };
  },
  async mounted() {
    if (!this.logout && !this.invalid) {
      const { code, session_state, state, error, error_description } =
        this.$route.query;
      const isKeycloakAuthenticated =
        code !== undefined &&
        session_state !== undefined &&
        state !== undefined;

      // Keycloak error
      if (error !== undefined) {
        this.error = `[Keycloak:${error}]: ${error_description}`;
        return;
      }

      if (!isKeycloakAuthenticated) {
        this.keycloakAuthentication();
      } else {
        this.connecting = true;
        try {
          // Don't have any other choices (vuex is buggy..)
          const user = await this.$parent.$data.userManager.signinCallback();
          if (user === null || user === undefined) {
            throw Error('User is null or undefined');
          }

          setTimeout(() => {
            if (this.error === null)
              this.error = this.$i18n.t('login.timedOut');
          }, TIMEOUT_DURATION);

          await this.kuzzleAuthentication();
        } catch (error) {
          this.error = error;
        }
      }
    }
  },
  methods: {
    async keycloakAuthentication() {
      const redirectUri = new URL(window.location.href);
      redirectUri.searchParams.delete('code');
      redirectUri.searchParams.delete('session_state');
      redirectUri.searchParams.delete('state');

      // No other way to change redirect_uri after init
      // Refactor this.$parent.$data, userManager should be in the store
      this.$parent.$data.userManager = createUserManager(redirectUri);
      await this.$parent.$data.userManager.signinRedirect();
    },
    async kuzzleAuthentication() {
      const visitorId = this.$store.state.app.visitorId;

      // REFACTOR : Use try/catch instead (beaware that Vue has a weird behaviour with exceptions inside store actions)
      const user = await this.$parent.$data.userManager.getUser();
      const error = await this.$store.dispatch('auth/LOGIN', {
        kuzzle: this.$kuzzle,
        strategy: keycloak.strategy,
        user,
        visitorId,
      });
      if (!error) {
        this.redirect();
      } else {
        this.error = error;
      }
    },
    redirect() {
      if (this.$route.query.to) {
        this.$router.push({ name: this.$route.query.to });
        return;
      }
      this.$router.push('/');
    },
  },
};
</script>
